import {
    CLOUDLOGINPAGE_UPLOAD_IMAGE_OPEN_MODAL,
    CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST,
    CLOUDLOGINPAGE_UPLOAD_IMAGE_RESULT,
    CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST,
    CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_RESULT
} from 'Redux/actionTypes';

export const imagesOpenModal = (open) => ({
    type: CLOUDLOGINPAGE_UPLOAD_IMAGE_OPEN_MODAL,
    payload: open
})

export const uploadImageRequest = (data) => ({
    type: CLOUDLOGINPAGE_UPLOAD_IMAGE_REQUEST,
    payload: data
})

export const uploadImageResult = (result) => ({
    type: CLOUDLOGINPAGE_UPLOAD_IMAGE_RESULT,
    payload: result
})

export const searchImageRequest = (data) => ({
    type: CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_REQUEST,
    payload: data
})

export const searchImageResult = (result) => ({
    type: CLOUDLOGINPAGE_UPLOAD_SEARCH_IMAGE_RESULT,
    payload: result
})
